var cidFromEthObj = require('./cidFromEthObj');

var asyncify = require('async/asyncify');

module.exports = createUtil;

function createUtil(multicodec, EthObjClass) {
  return {
    deserialize: asyncify(function (serialized) {
      return new EthObjClass(serialized);
    }),
    serialize: asyncify(function (ethObj) {
      return ethObj.serialize();
    }),
    cid: asyncify(function (ethObj, options) {
      return cidFromEthObj(multicodec, ethObj, options);
    })
  };
}